module.exports = __webpack_public_path__ + "ClientApp/images/content/euthanasia-slider/Dr-Dani-Appt-1.jpg";